import script from "./UserPicker.vue?vue&type=script&setup=true&lang=js"
export * from "./UserPicker.vue?vue&type=script&setup=true&lang=js"

import "./UserPicker.vue?vue&type=style&index=0&id=a5b1aef6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a5b1aef6"]])

export default __exports__